/**
 * 비CMS 출금 내역 (/adm/no-cms) — 월회비 차감 중 매니저 처리가 아닌 건 + 장기감면 제외자
 * ($j.Pages.Admin.NoCms / body data-page-name="NoCms")
 */
export default class NoCms {
    initialize() {
        const LANG = {
            emptyTable: '데이터가 없습니다.',
            info: '총 _TOTAL_건 중 _START_ ~ _END_',
            infoEmpty: '',
            zeroRecords: '일치하는 결과가 없습니다.',
            search: '검색:',
            paginate: { previous: '<', next: '>' },
        };

        new DataTable('#noCmsTable', {
            pageLength: 30,
            searching: false,
            lengthChange: false,
            ordering: true,
            language: LANG,
        });

        // 월 선택 → YYYYMM 쿼리로 재진입
        $('#searchForm').on('submit', function(e){
            e.preventDefault();
            const val = $('#monthInput').val().replace('-', '');
            location.href = '/adm/no-cms?month=' + val;
        });

        loadExcluded();

        function loadExcluded(){
            const monthCode = String($('#searchForm').data('month'));
            $.ajax({
                url:  '/adm/ajax/no-cms/excluded',
                type: 'POST',
                data: { month: monthCode },
                success: function(res){
                    if (!res.result) return;

                    // 전월 → 당월 제외자 정보 (필요 시 노출)
                    // $('#excludedInfo').text(`${res.prevMonth} 감면 → ${res.thisMonth} 제외된 회원`);

                    const $tbody = $('#excludedTable tbody');
                    $tbody.empty();
                    $.each(res.list, function(i, row){
                        $tbody.append(`<tr><td>${$j.F.Admin.Member.Pop.cellNo(row.num)}</td><td>${$j.Common.Util.escapeHtml(row.mem_name)}</td></tr>`);
                    });

                    // 기존 DataTables 인스턴스 정리 후 재초기화
                    if ($.fn.DataTable.isDataTable('#excludedTable')) {
                        $('#excludedTable').DataTable().destroy();
                    }
                    new DataTable('#excludedTable', {
                        pageLength: 30,
                        searching: false,
                        lengthChange: false,
                        ordering: true,
                        language: LANG,
                    });
                },
            });
        }
    }
}
